module.exports = __webpack_public_path__ + "static/media/badge-new-seasonal-512.b0a53e9f.png";